import type { FlexProps } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/react';
import Info from '@ui/components/Info';
import { useTranslations } from '@ui/i18n';
import React from 'react';

export type ApyInfoProps = {
  strategyApy: string;
  immediateApy: string;
} & FlexProps;

function StrategyApyInfo({
  strategyApy,
  immediateApy,
  ...flexProps
}: ApyInfoProps) {
  const t = useTranslations();
  return (
    <Flex
      gap={4}
      flexDir="column"
      px={{ base: 0, desktop: 8 }}
      py={{ base: 0, desktop: 4 }}
      minW={{ base: 'full', desktop: '407px' }}
      {...flexProps}
    >
      <Info title={t('Strategy APY')} value={strategyApy} />
      <Info title={t('Immediate APY')} value={immediateApy} />
      <Text>{t('strategy-apy-explainer')}</Text>
    </Flex>
  );
}

export default StrategyApyInfo;
